
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 305.406 305.406"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M123.901 137.703a9 9 0 009 9h80c4.971 0 9-4.029 9-9s-4.029-9-9-9h-80a9 9 0 00-9 9zM212.901 177.686h-80a9 9 0 00-9 9 9 9 0 009 9h80a9 9 0 009-9 9 9 0 00-9-9zM212.901 226.669h-80c-4.971 0-9 4.029-9 9s4.029 9 9 9h80c4.971 0 9-4.029 9-9s-4.029-9-9-9z"}}),_c('circle',{attrs:{"cx":"101.901","cy":"137.703","r":"9.396"}}),_c('circle',{attrs:{"cx":"101.901","cy":"186.686","r":"9.396"}}),_c('circle',{attrs:{"cx":"101.901","cy":"235.669","r":"9.396"}}),_c('path',{attrs:{"d":"M267.067 70.613L199.091 2.636A9.003 9.003 0 00192.727 0H44.703a9 9 0 00-9 9v287.406a9 9 0 009 9h216a9 9 0 009-9V76.977a9 9 0 00-2.636-6.364zm-67.34-41.885l41.249 41.249h-41.249V28.728zm51.976 258.678h-198V18h128.023v60.977a9 9 0 009 9h60.977v199.429z"}})])
          )
        }
      }
    